import {NodeProps} from 'reactflow';

import {
  AbstractDecisionTreeNode,
  DecisionTreeNode,
} from '../../../../libs/shared/core/src/helpers/types/decisionTreeTypes';
import {DecisionTreeNodeDataFrontChat} from '../../../../libs/shared/core/src/models/api/decisionTrees/decisionTreeNodeDataFrontChatModel';
import {TreeData} from '../../../../libs/shared/ui/src/components/decisionTrees/decisionTreeBuilder/types';
import {
  FlowBuilderStore,
  FlowBuilderValidation,
  SelectedNode,
} from '../../../../libs/shared/ui/src/components/decisionTrees/flowBuilder/types';
import {PreExpression} from '../../../settings/editors/expressions/expressionModel';
import {FlowBuilderExpressionsEditor} from '../flowBuilder/expressionHelpers';

/*
 * Enums.
 */

/**
 * Validations errors for nodes in the Chatbot builder. Errors may be used for multiple node data types.
 */
export enum ChatBotBuilderValidationErrorsEnum {
  EMPTY_LABEL = 'EMPTY_LABEL',
  EMPTY_MESSAGE = 'EMPTY_MESSAGE',
  MESSAGE_TOO_LONG = 'MESSAGE_TOO_LONG',
  MISSING_OPTIONS = 'MISSING_OPTIONS',
  TOO_MANY_KEYWORDS = 'TOO_MANY_KEYWORDS',
  EMPTY_TAGS = 'EMPTY_TAGS',
  EXPRESSION_TYPE_CHANGED = 'EXPRESSION_TYPE_CHANGED',
  INVALID_BETWEEN_OPTIONS = 'INVALID_BETWEEN_OPTIONS',
}

/**
 * Reasons for "downgrading" already used features in the chatbot builder. This matters when a node type
 * is no longer available following a change in company plan or loss of a feature.
 */
export enum ChatBotBuilderErrorReasonsEnum {
  IS_MISSING_PREMIUM_FEATURE = 'is_missing_premium_feature',
  IS_MISSING_AI_ANSWERS = 'is_missing_ai_answers',
  HAS_SUBTREE_BRANCH_ERRORS = 'has_subtree_branch_errors',
}

/*
 * Types.
 */

export interface ChatBotBuilderFeatureFlags {
  hasChatbotTransferConversation: boolean;
}

export type ChatBotAttachmentItem = {
  mimeType: string;
  fileSize: number;
  fileName: string;
  downloadUrl?: string;
  cid?: string;
  isErred?: boolean;
  isUploading?: boolean;
};
/**
 * The React Flow "data" field we control on each of our nodes.
 */
export type ChatBotBuilderNodeData = DecisionTreeNodeDataFrontChat;

export type ChatBotBuilderNode = DecisionTreeNode<ChatBotBuilderNodeData>;

export type ChatBotBuilderAbstractNode = AbstractDecisionTreeNode<ChatBotBuilderNodeData>;

export type ChatBotBuilderNodeProps = NodeProps<ChatBotBuilderNodeData>;

export type DeletePromptNodeWithDirty = (nodeId: string) => void;

export type ChatBotBuilderSelectedNode = SelectedNode<ChatBotBuilderNodeData>;

export type ChatBotBuilderState = TreeData<ChatBotBuilderNodeData> & {
  expressions: ReadonlyArray<PreExpression>;
};

export type ChatBotBuilderStore = FlowBuilderStore<
  ChatBotBuilderNodeData,
  ChatBotBuilderState,
  FlowBuilderExpressionsEditor
> & {
  deletePromptNodeWithDirty: DeletePromptNodeWithDirty;
};

export type ChatBotBuilderValidation = FlowBuilderValidation<ChatBotBuilderValidationErrorsEnum>;

export type ExitNodeLabelMap = Map<string, string | undefined>;
